import styled from "styled-components";

export const PurchaseSureWrap = styled.div`
  max-height: 60vh;
  min-height: 30vh;
  height: auto;
  width: 100%;
  overflow: hidden;

  .read-only--cell {
    background: #F5F4F4FF;
    color: #888;
    word-break: keep-all;
  }
`

export const TableWrap = styled.div`
  position: relative;
  overflow: hidden;
  flex: 1;
  /* overflow: auto; */

  .sticky-summary-cell{
    position: sticky;
    right: 106px;
    z-index: 2;
  }
  
  &.ant-table-cell-fix-right {
    z-index: 3 !important;
  }

  &.ant-table-summary {
    position: sticky;
    bottom: 0;
    z-index: 1;
    background: #fff;
  }

  .total-row {
    text-align: right;
    font-size: 18px;
    border: 1px #dfe3e7 solid;
    padding: 10px 80px;
  }
`

export const TableWrapNew = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  position: relative;
  overflow: hidden;
`
